// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2RKAQ","footer":"ModalUpdate_footer__3MvKm"};